import { Scaling, Landmark, PanelLeftClose, Building2 } from "lucide-react";

interface Spec {
  icon?: string;
  label: string;
  value: string;
}

interface SpecsBlockProps {
  content: {
    title?: string;
    subtitle?: string;
    specs?: Spec[];
  };
}

const iconMap: Record<string, React.ReactNode> = {
  area: <Scaling className="h-8 w-8 text-primary/60" strokeWidth={1.2} />,
  context: <Landmark className="h-8 w-8 text-primary/60" strokeWidth={1.2} />,
  layout: <PanelLeftClose className="h-8 w-8 text-primary/60" strokeWidth={1.2} />,
  typology: <Building2 className="h-8 w-8 text-primary/60" strokeWidth={1.2} />,
};

export function SpecsBlock({ content }: SpecsBlockProps) {
  if (!content.specs?.length) return null;

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-20">
      <div className="text-center mb-12">
        {content.title && (
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">
            {content.title}
          </h2>
        )}
        {content.subtitle && (
          <p className="font-sans text-sm text-muted-foreground">{content.subtitle}</p>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {content.specs.map((spec, i) => (
          <div
            key={i}
            className="border border-border bg-background flex flex-col items-center justify-center py-10 px-4"
          >
            <div className="mb-4">
              {spec.icon && iconMap[spec.icon]
                ? iconMap[spec.icon]
                : <Scaling className="h-8 w-8 text-primary/60" strokeWidth={1.2} />}
            </div>
            <p className="font-sans text-xs uppercase tracking-[0.15em] text-foreground font-medium mb-1">
              {spec.label}
            </p>
            <p className="font-sans text-sm text-muted-foreground">
              {spec.value}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
